import React from 'react'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

export const CustomNextArrow = (props) => {
    const {className, onClick, visibility = 'visible'} = props
    return (
        <Box
            className={className}
            onClick={onClick}
            sx={{
                _hover: {
                    opacity: 1,
                    svg: {
                        stroke: 'black'
                    }
                },
                zIndex: 1,
                cursor: 'pointer',
                visibility: visibility
            }}
        >
            <Box
                as="svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                width={{base: '30px', md: '44px'}}
                height={{base: '30px', md: '44px'}}
            >
                <polyline points="9 18 15 12 9 6" />
            </Box>
        </Box>
    )
}

CustomNextArrow.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    visibility: PropTypes.string
}

// CustomPrevArrow.jsx
export const CustomPrevArrow = (props) => {
    const {className, onClick, visibility = 'visible'} = props
    return (
        <Box
            className={className}
            onClick={onClick}
            sx={{
                _hover: {
                    opacity: 1,
                    svg: {
                        stroke: 'black'
                    }
                },
                zIndex: 1,
                cursor: 'pointer',
                visibility: visibility
            }}
        >
            <Box
                as="svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
                width={{base: '30px', md: '44px'}}
                height={{base: '30px', md: '44px'}}
            >
                <polyline points="15 18 9 12 15 6" />
            </Box>
        </Box>
    )
}

CustomPrevArrow.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    visibility: PropTypes.string
}
